import { checkJwt, useRedirect } from "@itarget/shared";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { auth, language as languageRedux } from "../../redux";
import {
  hashLinkFromUserPayload,
  isSsoEnabled,
  redirectToSsoAuthorize,
} from "../../utils/sso";
import DasboardView from "./views/DasboardView";

const DasboardContainer = () => {
	const routeParams = useParams();
	const { goTo } = useRedirect();
	const dispatch = useDispatch();
	const centerCostId = useSelector((state) => state.auth.cc);
	const ssoBridgeStarted = useRef(false);

	const resolveReturnPath = () => {
		if (routeParams?.page) {
			try {
				return decodeURIComponent(atob(routeParams.page));
			} catch (error) {
				return "new-panel";
			}
		}
		return "new-panel";
	};

	const onValidJwt = (validateJwt) => {
		if (isSsoEnabled() && !ssoBridgeStarted.current) {
			const hashLink = hashLinkFromUserPayload(validateJwt);
			if (hashLink) {
				ssoBridgeStarted.current = true;
				redirectToSsoAuthorize(
					resolveReturnPath(),
					centerCostId,
					hashLink
				);
				return;
			}
		}

		dispatch(auth.actions.setUser(validateJwt));
		dispatch(auth.actions.setIsAutenticated(true));
		if (routeParams?.page) {
			const decodedPage = decodeURIComponent(atob(routeParams.page));
			goTo(decodedPage);
			return;
		}
		goTo("new-panel");
	};

	const onInvalidJwt = useCallback(() => {
		dispatch(auth.actions.logout());
		return goTo(`offers-unique/${centerCostId}`);
	}, [centerCostId, goTo, dispatch]);

	const { isLoadingValidateJwt } = checkJwt({
		jwt: routeParams.jwt,
		centro_custo_id: centerCostId,
		onValid: onValidJwt,
		onInvalid: onInvalidJwt,
	});

	useEffect(() => {
		if (!routeParams.jwt && centerCostId) {
			const url = routeParams.url
				? atob(routeParams.url)
				: `offers-unique/${centerCostId}`;
			if (!routeParams.lang) {
				goTo(`${url}`);
				return;
			}
			const lang = routeParams.lang === "2" ? "en": routeParams.lang === "3" ? "es" : "pt-br";
			dispatch(languageRedux.actions.setLang(lang));
			goTo(`${url}`);
		}
	}, [routeParams, onInvalidJwt, centerCostId, goTo]);

	return <DasboardView isLoadingValidateJwt={isLoadingValidateJwt} />;
};

export default DasboardContainer;
